import React, { useState } from 'react';
import chemicalService from '../../../services/chemicalService';
import { generateLedgerPdf } from './ledgerPdf';

// party: { id, name }, partyType: 'vendor' | 'customer'
const LedgerPrintModal = ({ party, partyType, onClose }) => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [loading, setLoading] = useState(false);

  const handleGenerate = async () => {
    try {
      setLoading(true);
      const params = {};
      if (fromDate) params.from_date = fromDate;
      if (toDate) params.to_date = toDate;

      const res = await chemicalService.getPartyLedger(partyType, party.id, params);
      generateLedgerPdf(res.data, partyType, { from_date: fromDate, to_date: toDate });
      onClose();
    } catch (err) {
      alert('❌ ' + (err.response?.data?.message || 'Failed to generate ledger'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h3 style={styles.title}>Print Ledger — {party.name}</h3>

        <div style={styles.row}>
          <label style={styles.label}>From Date</label>
          <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} style={styles.input} />
        </div>
        <div style={styles.row}>
          <label style={styles.label}>To Date</label>
          <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} style={styles.input} />
        </div>
        <p style={styles.hint}>Leave blank to include full history up to today.</p>

        <div style={styles.actions}>
          <button onClick={onClose} style={styles.cancelButton} disabled={loading}>Cancel</button>
          <button onClick={handleGenerate} style={styles.generateButton} disabled={loading}>
            {loading ? 'Generating...' : '🖨️ Generate PDF'}
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
  },
  modal: {
    background: 'white', borderRadius: '12px', padding: '24px',
    width: '360px', boxShadow: '0 8px 30px rgba(0,0,0,0.2)',
  },
  title: { margin: '0 0 18px', fontSize: '17px', color: '#2c3e50' },
  row: { marginBottom: '12px' },
  label: { display: 'block', fontSize: '13px', fontWeight: '600', color: '#555', marginBottom: '4px' },
  input: {
    width: '100%', padding: '8px 10px', border: '2px solid #e0e0e0',
    borderRadius: '8px', fontSize: '14px', fontFamily: 'inherit', boxSizing: 'border-box',
  },
  hint: { fontSize: '12px', color: '#95a5a6', margin: '4px 0 18px' },
  actions: { display: 'flex', justifyContent: 'flex-end', gap: '10px' },
  cancelButton: {
    padding: '9px 16px', background: 'white', color: '#555',
    border: '2px solid #e0e0e0', borderRadius: '8px', cursor: 'pointer', fontWeight: '600',
  },
  generateButton: {
    padding: '9px 16px', background: '#e74c3c', color: 'white',
    border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '700',
  },
};

export default LedgerPrintModal;